import { fromJS, List, Record, Map } from 'immutable';
import _ from 'lodash';

import { properties as UserProperties } from '../user/model';

const properties = {
  ...UserProperties,
  createdAt: new Date(),
  locations: List(),
  roles: List(),
};

export default class Organizer extends Record(properties, 'Organizer') {
  public readonly id!: string;

  public readonly type!: string;

  public readonly createdAt!: Date;

  public readonly locations!: List<string>;

  public readonly roles!: List<string>;

  public readonly name!: string;

  public readonly email!: string;

  constructor(values: any = {}) {
    const validValues = _.pick(values, Object.keys(properties));
    super({
      ...validValues,
      type: values.type || values.__t, // eslint-disable-line
      fullName: Map(values.fullName),
      createdAt: values.createdAt ? new Date(values.createdAt) : undefined,
      locations: fromJS(values.locations || []),
      roles: fromJS(values.roles || []),
    });
  }
}
